import { render, staticRenderFns } from "./UserGroupTable.vue?vue&type=template&id=4e7c21f6&scoped=true"
import script from "./UserGroupTable.vue?vue&type=script&lang=js"
export * from "./UserGroupTable.vue?vue&type=script&lang=js"
import style0 from "./UserGroupTable.vue?vue&type=style&index=0&id=4e7c21f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7c21f6",
  null
  
)

export default component.exports